import { WebMCPToolDefinition } from '../types/webmcp';
import { initializeWebMCPPolyfill } from './polyfill';

export class WebMCPRegistry {
  private static instance: WebMCPRegistry;
  private polyfill = initializeWebMCPPolyfill();

  private constructor() {}

  public static getInstance(): WebMCPRegistry {
    if (!WebMCPRegistry.instance) {
      WebMCPRegistry.instance = new WebMCPRegistry();
    }
    return WebMCPRegistry.instance;
  }

  public register(tool: WebMCPToolDefinition): void {
    this.polyfill.registerTool(tool);
  }

  public getTools(): WebMCPToolDefinition[] {
    return this.polyfill.getTools();
  }

  public getTool(name: string): WebMCPToolDefinition | undefined {
    return this.polyfill.getTool(name);
  }

  public async execute(name: string, input: any, caller?: any): Promise<any> {
    return this.polyfill.executeTool(name, input, caller);
  }

  public getOpenAISchemas(): Array<{
    type: 'function';
    function: {
      name: string;
      description: string;
      parameters: any;
    };
  }> {
    return this.polyfill.getTools().map((tool) => ({
      type: 'function',
      function: {
        name: tool.name,
        description: tool.description,
        parameters: tool.inputSchema,
      },
    }));
  }
}

export const webMCPRegistry = WebMCPRegistry.getInstance();
